import lrVxeTable from './_src/lrVxeTable.vue'

lrVxeTable.install = function(Vue) {
  Vue.component(lrVxeTable.name, lrVxeTable)
}

export default lrVxeTable